export default __webpack_public_path__ + "static/media/discord-black.35c5a30d.svg";